import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.21 5.355 20.509 2h2.796L3.697 22H.905l4.603-4.683a16.628 16.628 0 0 1-1.661-1.493 20.232 20.232 0 0 1-2.109-2.553 23.465 23.465 0 0 1-1.042-1.689c.324-.58.668-1.14 1.042-1.688A20.232 20.232 0 0 1 3.847 7.34c2.325-2.377 4.955-3.825 7.849-3.825 1.964 0 3.806.667 5.515 1.839ZM6.92 15.875l1.713-1.751a4.072 4.072 0 0 1-.882-2.542c0-2.227 1.767-4.033 3.946-4.033.942 0 1.808.338 2.486.902l1.6-1.636c-1.31-.826-2.678-1.282-4.086-1.282-2.285 0-4.464 1.2-6.454 3.233a17.997 17.997 0 0 0-2.246 2.816c.674 1.002 1.403 1.955 2.246 2.816a14.197 14.197 0 0 0 1.677 1.477Zm5.853-5.983a1.933 1.933 0 0 0-1.076-.326c-1.09 0-1.973.903-1.973 2.016 0 .406.117.784.32 1.1l2.729-2.79Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9.173 19.274a8.75 8.75 0 0 0 2.523.374c2.894 0 5.523-1.447 7.849-3.824a20.002 20.002 0 0 0 3.15-4.242 20.66 20.66 0 0 0-2.515-3.559l-1.397 1.428a20.76 20.76 0 0 1 1.613 2.131c-.67 1.001-1.407 1.958-2.246 2.816-1.99 2.034-4.17 3.234-6.454 3.234-.289 0-.576-.02-.86-.057l-1.663 1.7Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconActionHide24 = createIcon(IconComponent);